import React from "react";
import { Box, Stack } from "@mui/material";
import { ColorSystemProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";

const { baseUrl } = parlorRegion;

const SIDOS = [
  { code: "32", name: "강원", tag: "도", desc: "춘천·강릉·원주·속초 등 주요 도시 장례식장" },
];

export function SidoNav({
  currentSidoCode,
  mainColor,
}: {
  currentSidoCode: string;
  mainColor: ColorSystemProps;
}) {
  return (
    <Stack padding="40px 20px 56px">
      <Box
        component="h2"
        style={{ fontSize: "24px", fontWeight: 700, color: "#252525" }}
      >
        강원도 장례식장 안내
      </Box>
      <Box
        component="p"
        style={{ marginTop: "14px", fontSize: "16px", lineHeight: 1.75, color: "#535353", maxWidth: "720px" }}
      >
        강원도 장례식장 위치·빈소·비용을 지역별로 확인하세요.
        {" "}고이장례연구소에서는 강원도 장례식장 위치·빈소·비용을 지역별로 안내해드리고 있습니다.{" "}
        <Box component="span" style={{ fontSize: "12px", color: "#888" }}>
          e하늘 장사정보시스템 기반
        </Box>
      </Box>
      <Box
        style={{ marginTop: "28px", display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "10px" }}
        sx={{ "@media (min-width: 640px)": { gridTemplateColumns: "repeat(2, 1fr)", gap: "14px" } }}
      >
        {SIDOS.map((sido) => {
          const isCurrent = currentSidoCode === sido.code;
          return (
            <Box
              key={sido.code}
              component="a"
              href={`${baseUrl}/gangwon-parlors/${sido.name}도 의 장례식장들/`}
              style={{
                background: isCurrent ? mainColor.c100 : "#fff",
                border: `1px solid ${isCurrent ? mainColor.c400 : "#e9e9e9"}`,
                borderRadius: "12px",
                padding: "20px 18px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                textDecoration: "none",
              }}
            >
              <Box style={{ fontSize: "11px", fontWeight: 700, color: mainColor.c500, letterSpacing: "0.04em" }}>
                {sido.tag}{isCurrent ? " · 현재 지역" : ""}
              </Box>
              <Box style={{ fontSize: "17px", fontWeight: 700, color: "#252525", marginTop: "2px" }}>
                {sido.name}
              </Box>
              <Box style={{ fontSize: "12px", color: "#686868", marginTop: "4px", lineHeight: 1.55 }}>
                {sido.desc}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
}
